const SECTION_SELECTOR = '[data-section]';
const BUBBLE_HIDE_BREAKPOINT = 767;

let nav = null;
let sections = [];
let activeIndex = -1;
let isHidden = true;
let ticking = false;

function createNav() {
  if (nav) return;
  nav = document.createElement('nav');
  nav.className = 'nav-bubble';
  nav.setAttribute('aria-label', 'Section navigation');
  nav.style.opacity = '0';
  document.body.appendChild(nav);
}

function buildDots() {
  if (!nav) return;
  nav.innerHTML = '';
  // The dots are new elements with no active state — reset the tracker so the
  // next updateActive() re-applies is-active (otherwise it early-returns when
  // the index is unchanged, e.g. on the second setup() from page:load).
  activeIndex = -1;
  sections.forEach(function (el, i) {
    var label = el.getAttribute('data-nav-label') || '';
    var btn = document.createElement('button');
    btn.className = 'nav-bubble__dot';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Go to ' + label);
    btn.dataset.index = i;

    var labelEl = document.createElement('span');
    labelEl.className = 'nav-bubble__label';
    labelEl.textContent = label;

    var dot = document.createElement('span');
    dot.className = 'nav-bubble__circle';

    btn.appendChild(labelEl);
    btn.appendChild(dot);

    btn.addEventListener('click', function () {
      // Home sections are full-viewport (100svh) slides, so align the slide top
      // with the viewport top. Subtracting the header height would push the
      // slide's bottom (and its .slide-cta button) below the fold — and the
      // sticky header hides on scroll-down anyway.
      var top = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });

    nav.appendChild(btn);
  });
}

function scanSections() {
  sections = Array.from(document.querySelectorAll(SECTION_SELECTOR));
}

function updateActive() {
  if (!sections.length) return;

  var best = -1;
  var bestDist = Infinity;

  sections.forEach(function (el, i) {
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      var dist = Math.abs(rect.top);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
  });
  if (best !== activeIndex) {
    activeIndex = best;
    var dots = nav.querySelectorAll('.nav-bubble__dot');
    dots.forEach(function (d, idx) {
      d.classList.toggle('is-active', idx === activeIndex);
      if (idx === activeIndex) {
        d.setAttribute('aria-current', 'step');
      } else {
        d.removeAttribute('aria-current');
      }
    });
  }

  var heroRect = sections[0] ? sections[0].getBoundingClientRect() : null;
  var lastRect = sections[sections.length - 1] ? sections[sections.length - 1].getBoundingClientRect() : null;
  var shouldHide = true;

  if (heroRect && lastRect) {
    var pastLast = lastRect.bottom < 0;
    var beforeFirst = heroRect.top > window.innerHeight;
    shouldHide = pastLast || beforeFirst;
  }

  if (shouldHide !== isHidden) {
    isHidden = shouldHide;
    nav.style.opacity = isHidden ? '0' : '1';
  }
}

function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(function () {
      updateActive();
      ticking = false;
    });
    ticking = true;
  }
}

let listenersAttached = false;

function attachListeners() {
  if (listenersAttached) return;
  listenersAttached = true;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
}

function setup() {
  if (window.matchMedia('(max-width: ' + BUBBLE_HIDE_BREAKPOINT + 'px)').matches) return;
  if (document.documentElement.dataset.input === 'touch') return;
  scanSections();
  if (!sections.length) {
    if (nav) nav.style.display = 'none';
    return;
  }
  createNav();
  if (nav) nav.style.display = '';
  buildDots();
  updateActive();
  attachListeners();
  // Re-run after layout settles (the first pass can see sections with no height
  // yet) so the correct dot is highlighted on first load.
  requestAnimationFrame(updateActive);
  window.addEventListener('load', updateActive, { once: true });
}

document.addEventListener('DOMContentLoaded', setup);
document.addEventListener('page:load', setup);
